import { canonicalJson } from './json'
import { selectionTargets, setControl } from './selection'
import type { ActionOption } from './types'

/** One legal command may be offered on several physical components, including set-option toggles. */
export function actionTargets(action: ActionOption): readonly string[] {
  return [...new Set([...(action.targetId ? [action.targetId] : []), ...(action.targetIds ?? []), ...selectionTargets(action)])]
}

/** The actions offered to one kind of player. Actions without an audience are offered to everyone. */
export function audienceActions(actions: readonly ActionOption[], audience: 'human' | 'bot'): readonly ActionOption[] {
  return actions.filter(action => action.audience === undefined || action.audience === audience)
}

/** Bots never need inference for one exact command; humans require author opt-in. */
export function automaticAction(actions: readonly ActionOption[], mode: 'human' | 'bot' = 'human'): ActionOption | undefined {
  // A set-controlled action is a template until a player chooses its values.
  if (actions.some(setControl)) return undefined
  const authored = actions.filter(action => action.autoResolve)
  if (authored.length === 1) return authored[0]
  const resolvers = actions.filter(action => action.resolver)
  if (new Set(resolvers.map(action => action.resolver!.id)).size === 1
    && resolvers.length && resolvers.every(action => !action.resolver!.confirmation)
    && new Set(resolvers.map(action => canonicalJson(action.command))).size === 1) return resolvers[0]
  if (mode === 'bot' && actions.length && new Set(actions.map(action => canonicalJson(action.command))).size === 1) return actions[0]
  return undefined
}

/** Host pacing, independent of animation completion or even the presence of a browser. */
export const AUTO_RESOLVE_DELAY_MS = 1800
